export const RULE_CATEGORIES = {
  LIMITS: "limits",
  USER_LIMIT: "user-limit",
  USER_WINNING_LIMIT: "user-winning-limit",
  REWARD_LIMIT: "reward-limits",
  USER_REWARD_LIMITS: "user-reward-limits",
};

export const CATEGORY_METADATA = [
  {
    id: RULE_CATEGORIES.USER_LIMIT,
    name: "Participation Limit per User",
    description:
      "Set the total number of times a user can participate in the campaign within a defined time period.",
  },
  {
    id: RULE_CATEGORIES.LIMITS,
    name: "Total Participation Limit",
    description:
      "Set the total number of participations allowed for this campaign across all users within a defined time period.",
  },
  {
    id: RULE_CATEGORIES.USER_WINNING_LIMIT,
    name: "Winning Limit per User",
    description:
      "Set the total number of times a user can win in the campaign within a defined time period.",
  },
  {
    id: RULE_CATEGORIES.REWARD_LIMIT,
    name: "Reward Limit per Campaign",
    description:
      "Set the total number of times a reward can be given for this campaign across all users within a defined time period.",
  },
  {
    id: RULE_CATEGORIES.USER_REWARD_LIMITS,
    name: "Reward Limit per User",
    description:
      "Set the total number of times a reward can be given to a single user within a defined time period.",
  },
];

/**
 * Gets the explicitly configured category for a rule.
 * Uncategorized rules are excluded from the category-based UI.
 * @param {Object} rule - The rule object
 * @returns {string|null} - The category id
 */
export const getCategoryForRule = (rule) => {
  if (!rule?.category) {
    return null;
  }

  // Normalize "limit" to "limits" for consistency
  if (rule.category === "limit") {
    return RULE_CATEGORIES.LIMITS;
  }

  return rule.category;
};

/**
 * Gets the display name of the category for a given rule
 * @param {Object} rule - The rule object
 * @returns {string} - The category name
 */
export const getCategoryName = (rule) => {
  const categoryId = getCategoryForRule(rule);
  const category = CATEGORY_METADATA.find((cat) => cat.id === categoryId);
  return category?.name || categoryId;
};
